import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import content from "../data/content.json";
import { resolveAssetPath } from "../utils/content";
import "./Navbar.css";

const navItems = [
  { label: "Home", href: "#home" },
  { label: "Skills", href: "#skills" },
  { label: "Education", href: "#education" },
  { label: "Projects", href: "#projects" },
  { label: "Works", href: "#works" },
  { label: "Contact", href: "#contact" },
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isPostersPage = location.pathname === '/works/posters';

  const logoSrc = resolveAssetPath(content.site?.brand?.logo || "/assets/brand/Untitlsed-1.png");

  useEffect(() => {
    const closeMenuOnResize = () => {
      if (window.innerWidth > 760) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", closeMenuOnResize);
    return () => window.removeEventListener("resize", closeMenuOnResize);
  }, []);

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`navbar-wrap ${isPostersPage ? 'hide-on-desktop' : ''}`}>
      <nav className="navbar">
        <Link className="nav-logo" to="/#home" onClick={handleNavClick}>
          <img src={logoSrc} alt="Logo" />
        </Link>

        <ul className="nav-links">
          {navItems.map((item) => (
            <li key={item.href}>
              <Link to={`/${item.href}`}>{item.label}</Link>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className={`nav-menu-btn ${isMenuOpen ? "open" : ""}`}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-nav-menu"
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div id="mobile-nav-menu" className={`mobile-nav-menu ${isMenuOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <Link key={item.href} to={`/${item.href}`} onClick={handleNavClick}>
            {item.label}
          </Link>
        ))}
      </div>
    </header>
  );
}

export default Navbar;
